import { c as _c } from "react/compiler-runtime";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { canUseTeamsSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";

/** Everything the current user is allowed to do with the teams of the selected workspace. */

/**
 * Combines the company role of the user with the teams feature of the workspace subscription.
 *
 * A workspace that lost the teams feature keeps the teams it created earlier, but only in a
 * read-only state: those teams can still be listed, opened, emptied and removed, while everything
 * that would create or grow a team is no longer allowed.
 */
export function useTeamsAccess() {
  const $ = _c(7);
  const canUseTeams = useAppSelector(canUseTeamsSelector);
  const {
    canCreateNewTeam,
    canEditTeams,
    canDeleteTeams,
    canInviteMembersToTeam,
    canDeleteMembersFromTeam,
    canEditMember
  } = useHasUserValidRoleCompanyLevel();
  const t0 = canCreateNewTeam && canUseTeams;
  const t1 = canEditTeams && canUseTeams;
  const t2 = canInviteMembersToTeam && canUseTeams;
  const t3 = canEditMember && canUseTeams;
  let t4;
  if ($[0] !== canDeleteMembersFromTeam || $[1] !== canDeleteTeams || $[2] !== t0 || $[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      canDeleteTeams,
      canDeleteMembersFromTeam,
      canCreateNewTeam: t0,
      canEditTeams: t1,
      canInviteMembersToTeam: t2,
      canChangeTeamRole: t3
    };
    $[0] = canDeleteMembersFromTeam;
    $[1] = canDeleteTeams;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}